/* eslint-disable */
export default {
  _happy_halloween: 'happy_halloween',
}